import { GENERATING_DOCUMENT } from '../actions';

export default ( state = '', action ) => {
	switch ( action.type ) {
		case GENERATING_DOCUMENT:
			let doc_index = state.indexOf( action.payload );
			if ( doc_index !== -1 ) {
				let newState = [
					...state.slice( 0, doc_index ),
					...state.slice( doc_index + 1 )
				];
				return [ ...newState ];
			} else {
				return [ ...state, action.payload ];
			}

	}
	return state;
}